/* -----------------Globals--------------- */
import { Platform } from "react-native";

/* -----------------UI--------------- */
import { Appbar } from "react-native-paper";
import Box from "../Box";
import TooltipWrapper from "../TooltipWrapper";
import { AppBarMenu } from "./AppBarMenu";

import Icon from "@expo/vector-icons/MaterialCommunityIcons";
/* -----------------Helpers & Hooks--------------- */
import { defaultAiAssistantInfo } from "@memorang/helpers/src/constants";

import { memo } from "react";
import type { IconType } from "../../types";
/* -----------------Types--------------- */
import type { ChatAppbarProps } from "./types/props";

const BackButton = memo(
	({
		backAction,
	}: { backAction: NonNullable<ChatAppbarProps["backAction"]> }) => {
		return (
			<Appbar.Action
				icon={backAction.icon}
				onPress={backAction.handleAction}
				size={backAction.size}
			/>
		);
	},
);

const ChatAppbar = (props: ChatAppbarProps) => {
	const {
		actions = [],
		menuActions = [],
		title = defaultAiAssistantInfo.title,
		isBackButtonVisible = true,
		backAction,
	} = props;

	return (
		<Appbar.Header
			elevated
			mode="center-aligned"
			statusBarHeight={Platform.OS === "android" ? 16 : 0}
		>
			{isBackButtonVisible && <BackButton backAction={backAction} />}
			<Box gap={2} flex={1}>
				<Appbar.Content
					title={title}
					style={{
						flex: 0,
					}}
				/>
			</Box>
			{actions.map(({ icon, handleAction, title, disabled }) => (
				<TooltipWrapper title={title} key={icon}>
					<Appbar.Action
						icon={(props) => <Icon {...props} name={icon as IconType} />}
						onPress={handleAction}
						disabled={disabled}
					/>
				</TooltipWrapper>
			))}
			{menuActions.length > 0 && <AppBarMenu menuActions={menuActions} />}
		</Appbar.Header>
	);
};

export default ChatAppbar;
